import { Carousel } from "flowbite-react"
import { useState } from "react"
import WarningModal from "../components-modals/WarningModal"

/*const Publicidad = ({ slides }) => {

    const [open, setOpen] = useState(true)

    return(
        <>
            <Loading
                open={open}
                setOpen={setOpen}
            />
            <div className='hidden lg:block h-132 lg:basis-2/3 rounded-l-2xl bg-primario'>
                <Carousel slideInterval={5000}>
                    {slides.map((slide)=> <img onLoad={() => setOpen(false)} key={slide.src} alt={slide.alt} src={slide.src}/>)}
                </Carousel>
            </div>
        </>
    )
}*/

const Publicidad = ({ slides }) => {

    const [open, setOpen] = useState(true)

    return (
        <>
            <WarningModal
                open={open}
                image={<img src='img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />
            <div className='hidden lg:block h-140 lg:basis-2/3 rounded-l-2xl bg-primarioMira'>
                <Carousel slideInterval={5000}>
                    {slides.map((slide) => <img onLoad={() => setOpen(false)} key={slide.src} alt={slide.alt} src={slide.src} />)}
                </Carousel>
            </div>
        </>
    )
}

export default Publicidad